"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Copyable = _interopRequireDefault(require("../../models/Copyable"));

var _isArray = _interopRequireDefault(require("./isArray"));

var _isDate = _interopRequireDefault(require("./isDate"));

var _isFunction = _interopRequireDefault(require("./isFunction"));

var _isObject = _interopRequireDefault(require("./isObject"));

var deepCopy = function deepCopy(elt) {
  if (typeof elt === 'undefined') {
    return undefined;
  }

  if (elt === null) {
    return null;
  }

  var copy = elt;

  if ((0, _isArray["default"])(elt)) {
    copy = elt.map(deepCopy);
  } else if ((0, _isDate["default"])(elt)) {
    copy = new Date(elt.getTime());
  } else if (_Copyable["default"].isCopyable(elt)) {
    copy = elt.copy();
  } else if ((0, _isFunction["default"])(elt.copy)) {
    copy = elt.copy();
  } else if (elt instanceof Map) {
    copy = new Map(deepCopy(Array.from(elt)));
  } else if (elt instanceof Set) {
    copy = new Set(deepCopy(Array.from(elt)));
  } else if ((0, _isObject["default"])(elt)) {
    copy = new elt.constructor();
    var keys = Object.keys(elt);
    keys.forEach(function (key) {
      copy[key] = deepCopy(elt[key]);
    });
  }

  return copy;
};

var _default = deepCopy;
exports["default"] = _default;